// Centrale send-poort (C2): haalt het token uitsluitend op via de
// SECURITY DEFINER-functie get_pushable_token(s), die zowel
// autorisatie als de push_preferences-check afdwingt. category=null
// (niet-uitschakelbare typen) slaat de preference-check bewust over.

export async function sendPushToTokens(supabase, coachId, clientIds, category, title, body) {
  const ids = (clientIds || []).filter(Boolean);
  if (ids.length === 0) return { successCount: 0, total: 0 };

  const { data: pushable, error: pushableErr } = await supabase.rpc('get_pushable_tokens', {
    p_user_ids: ids,
    p_category: category,
  });
  if (pushableErr) throw pushableErr;
  const eligible = (pushable || []).filter(r => r.push_token);

  const results = await Promise.allSettled(
    eligible.map(({ push_token }) =>
      supabase.functions.invoke('send-push', {
        body: [{ to: push_token, title, body }],
      })
    )
  );

  // Onderdeel 4 (2026-07-25): een `fulfilled` invoke betekende alleen dat de
  // Edge Function bereikbaar was. Expo weigert een bericht binnen een
  // HTTP-200-respons, dus elke mislukte push telde als succes. send-push
  // rapporteert nu `accepted`; een oudere deploy zonder dat veld valt terug
  // op het oude gedrag.
  const successCount = results.filter(r => {
    if (r.status !== 'fulfilled' || r.value?.error) return false;
    const accepted = r.value?.data?.accepted;
    return typeof accepted === 'number' ? accepted > 0 : true;
  }).length;

  const recipientIds = eligible.map(r => r.user_id);
  if (successCount > 0 && recipientIds.length > 0) {
    await supabase.from('push_logs').insert({
      coach_id: coachId,
      type: 'selective',
      recipient_ids: recipientIds,
      title,
      body,
      success_count: successCount,
    });
  }

  return { successCount, total: ids.length };
}

export async function sendPushToClient(supabase, coachId, clientId, category, title, body) {
  if (!clientId) return { success: false };
  const { data: token, error: tokenErr } = await supabase.rpc('get_pushable_token', {
    p_user_id: clientId,
    p_category: category,
  });
  if (tokenErr) throw tokenErr;
  if (!token) return { success: false };
  const result = await supabase.functions.invoke('send-push', {
    body: [{ to: token, title, body }],
  });
  const accepted = result.error
    ? 0
    : (typeof result.data?.accepted === 'number' ? result.data.accepted : 1);
  if (accepted > 0) {
    await supabase.from('push_logs').insert({
      coach_id: coachId,
      type: 'individual',
      recipient_ids: [clientId],
      title,
      body,
      success_count: accepted,
    });
  }
  return { success: accepted > 0 };
}
